import React from "react";
import { Icon } from "@iconify/react";
import { Tooltip } from "react-tooltip";
import { TOOLTIP_WORD_LIMIT, firstSentence, wordCount } from "./settingsMeta";

/**
 * The "i" beside a control label: hover for a preview, click for the rest.
 *
 * TWO TIERS ON PURPOSE. Twenty-four of the thirty-seven switches carry help
 * longer than 25 words and one carries 142, and a tooltip that size covers the
 * very switch it is explaining. So short help renders in full on hover, and
 * long help previews on hover and opens IN PLACE below the row.
 *
 * 🔴 THIS IS A REAL <button>, NOT A HOVER TARGET. Hover is the shortcut; the
 * button is the mechanism. A mouse, a finger and the Enter key all do the same
 * thing, and Escape closes it. Nothing on this page is reachable by hover
 * alone, which matters on a console an operator may be driving from a laptop
 * trackpad at 200% zoom where a 380px popover covers the row underneath it.
 *
 * 🔴 data-tooltip-id GOES ON THE BUTTON, NEVER ON THE <Icon>. An Iconify icon
 * renders an <svg>, and a tooltip id on an svg renders nothing at all (the
 * lesson recorded at CompatibilityListLayer.jsx:189, 2026-09-01).
 *
 * Help strings carry embedded double quotes ("We have a plan"), braces
 * ({Name}) and apostrophes, so the text is passed as CHILDREN of <Tooltip>,
 * never through a title= or data-tooltip-html= attribute where it would need
 * escaping and would arrive mangled.
 */
const HelpButton = ({ name, help, open, onToggle }) => {
  const words = wordCount(help);
  const short = words <= TOOLTIP_WORD_LIMIT;
  const id = `help-tip-${name}`;

  return (
    <>
      <button
        type="button"
        className="btn btn-link p-0 border-0 d-inline-flex align-items-center text-secondary-light"
        style={{ lineHeight: 1, verticalAlign: "middle" }}
        aria-expanded={open}
        aria-controls={`help-panel-${name}`}
        aria-label={open ? "Hide help" : "Show help"}
        onClick={onToggle}
        data-tooltip-id={id}
      >
        <Icon icon="ic:baseline-info" style={{ fontSize: "1rem" }} />
      </button>
      <Tooltip
        id={id}
        place="right"
        clickable
        style={{
          maxWidth: 380,
          // 1080 clears the sticky save bar and the navbar. The zIndex: "1"
          // used elsewhere in this app would put the popover underneath both.
          zIndex: 1080,
          fontSize: 12.5,
          lineHeight: 1.5,
        }}
      >
        <span style={{ display: "block", maxWidth: 356 }}>
          {short ? help : firstSentence(help)}
          {!short && (
            <span style={{ display: "block", marginTop: 6, opacity: 0.8 }}>
              Click to open the rest ({words} words)
            </span>
          )}
        </span>
      </Tooltip>
    </>
  );
};

export default HelpButton;
